import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router"
import { App } from "./App"

import packageProps from "./../package.json"

const getVersionWithEmoji = (version) => {
  const fruits = ["🍎", "🍌", "🍒", "🍇", "🍉", "🍊", "🍋", "🍓", "🥝", "🍍"]
  const lastDigit = parseInt(version.split(".").pop(), 10)
  const emoji = fruits[lastDigit % 10]
  return `${emoji}  ${version}`
}

const version = packageProps.version
console.log(getVersionWithEmoji(version))

const container = document.getElementById("app")
const root = createRoot(container)
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
)
